import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { includesPath } from './components/utils'

export const useShowSideNav = () => {
  const [showNavOnThisRoute, setShowNavOnThisRoute] = useState(false)
  const location = useLocation()
  useEffect(() => {
    setShowNavOnThisRoute(
      includesPath(
        location.search
          ? `${location.pathname}${location.search}`
          : location.pathname,
      ),
    )
  }, [location])

  return { showNavOnThisRoute, setShowNavOnThisRoute }
}

export const useShowNavBar = () => {
  const [showNavBar, setShowNavBar] = useState(false)
  const location = useLocation()

  const notAllowedUrls = [
    '/settings/my-subscription/cancel-subscription/success',
    '/settings/my-subscription/close-account/pending',
    '/settings/my-subscription/close-account/success',
  ]

  useEffect(() => {
    setShowNavBar(notAllowedUrls.some((url) => location.pathname.includes(url)))
  }, [location])

  return { showNavBar }
}
